
<template>
  <div class="index_header_box">
    <div class="left">
      <img
        @click="LogoClickHomne"
        style="cursor: pointer;"
        class="company"
        src="../assets/image/company_logo.png"
        alt
      />
      <el-button
        class="selectClass"
        v-if="department_model_header=='1'"
        @click="handleSelectClick"
      >{{selectName=='全部'?'选择侧重部门':selectName}}</el-button>
      <ul class="index_tabs">
        <li @click="handleIndexTabsClick('1')" :class="tabsCurrent=='1'?'indexTabsActive':''">
          <div style="margin-bottom:9px;">首页</div>
          <div v-show="tabsCurrent=='1'" class="underLine"></div>
        </li>
        <li @click="handleIndexTabsClick('2')" :class="tabsCurrent=='2'?'indexTabsActive':''">
          <!-- <div style="margin-bottom:9px;">项目</div> -->
          <!-- 下啦开始 -->
          <el-dropdown class="tabs_dropdown">
            <div class="el-dropdown-link" style="margin-bottom:9px;font-size:18px">项目</div>
            <el-dropdown-menu slot="dropdown">
              <div class="drop_container adminDropContainer">
                <div class="adminItem">
                  <div class="adminTitle">过控项目</div>
                  <ul class="itemsContainer statisticsItemsContainer">
                    <li @click="goProject(1)">项目列表</li>
                  </ul>
                </div>
                <div class="adminItem">
                  <div class="adminTitle">业务汇报</div>
                  <ul class="itemsContainer">
                    <li @click="goProject(2)">业务列表</li>
                  </ul>
                </div>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- 下啦结束 -->
          <div v-show="tabsCurrent=='2'" class="underLine"></div>
        </li>
        <li @click="handleIndexTabsClick('3')" :class="tabsCurrent=='3'?'indexTabsActive':''">
          <div style="margin-bottom:9px;">财务</div>
          <div v-show="tabsCurrent=='3'" class="underLine"></div>
        </li>
        <li @click="handleIndexTabsClick('7')" :class="tabsCurrent=='7'?'indexTabsActive':''">
          <div style="margin-bottom:9px;">行政</div>
          <div v-show="tabsCurrent=='7'" class="underLine"></div>
        </li>
        <li @click="handleIndexTabsClick('8')" :class="tabsCurrent=='8'?'indexTabsActive':''">
          <div style="margin-bottom:9px;">工具</div>
          <div v-show="tabsCurrent=='8'" class="underLine"></div>
        </li>
        <li @click="handleIndexTabsClick('4')" :class="tabsCurrent=='4'?'indexTabsActive':''">
          <div style="margin-bottom:9px;">客户管理</div>
          <div v-show="tabsCurrent=='4'" class="underLine"></div>
        </li>
        <li @click="handleIndexTabsClick('5')" :class="tabsCurrent=='5'?'indexTabsActive':''">
          <div style="margin-bottom:9px;">知识库</div>
          <div v-show="tabsCurrent=='5'" class="underLine"></div>
        </li>
        <li @click="handleIndexTabsClick('6')" :class="tabsCurrent=='6'?'indexTabsActive':''">
          <el-dropdown class="tabs_dropdown">
            <div class="el-dropdown-link" style="margin-bottom:9px;font-size:18px">管理</div>

            <el-dropdown-menu slot="dropdown">
              <div class="drop_container adminDropContainer">
                <div class="adminItem">
                  <div class="adminTitle">组织架构</div>
                  <ul class="itemsContainer">
                    <li @click="goAdmin('成员管理')">成员管理</li>
                    <li @click="goAdmin('部门管理')">部门管理</li>
                    <li @click="goAdmin('系统公告')">系统公告</li>
                  </ul>
                </div>
                <div class="adminItem">
                  <div class="adminTitle">统计</div>
                  <ul class="itemsContainer">
                    <li @click="goAdmin('项目统计')">项目统计</li>
                    <li @click="goAdmin('业务考核')">业务考核</li>
                  </ul>
                </div>
                <div class="adminItem">
                  <div class="adminTitle">OA</div>
                  <ul class="itemsContainer itemsContainerss">
                    <li @click="goAdmin('项目设置')">项目设置</li>
                    <li @click="goAdmin('审批设置')">审批设置</li>
                    <li @click="goAdmin('考勤管理')" v-if="punchDisable">考勤管理</li>
                    <!-- <li @click="goAdmin('编号设置')">编号设置</li> -->
                  </ul>
                </div>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
          <div v-show="tabsCurrent=='6'" class="underLine"></div>
        </li>
      </ul>
    </div>
    <div class="right">
      <el-tooltip class="item" transition="none" effect="dark" content="我的备忘" placement="bottom">
        <img class="logo_position" @click="goMyTodo" src="../assets/image/icon_bq@2x.png" alt />
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        transition="none"
        content="我的流程(待办)"
        placement="bottom"
      >
        <el-badge v-if="numData.all>0" :value="numData.all" :max="99" class="item">
          <img
            style="margin-top:5px"
            class="logo_fly"
            @click="goMyFlow"
            src="../assets/image/icon_fx@2x.png"
            alt
          />
        </el-badge>
        <img
          v-else
          style="margin-top:5px"
          class="logo_fly"
          @click="goMyFlow"
          src="../assets/image/icon_fx@2x.png"
          alt
        />
      </el-tooltip>

      <img class="logo_setting" @click="settingClick" src="../assets/image/icon_sz@2x.png" alt />
      <!-- @mouseover="isSelectShow = true" -->
      <!-- @mouseout="isSelectShow = false" -->
      <img class="header" @click="headerClick" v-if="avatarUrl" :src="avatarUrl" alt />
      <img
        class="header"
        v-else
        @click="headerClick"
        src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
        alt
      />
    </div>
    <!-- 头像下拉框 -->
    <transition name="el-zoom-in-top">
      <div v-show="isSelectShow" class="headerSlid">
        <div class="headerInfor">
          <div class="SlidLeft">
            <!-- <img class="sildHeader" src="../assets/image/headerLogio.png" alt /> -->
            <img class="sildHeader" v-if="avatarUrl" :src="avatarUrl" alt />
            <img
              class="sildHeader"
              v-else
              src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
              alt
            />
          </div>
          <div class="SlidRight">
            <p
              :title="indexInfo.memberinfo.nickname"
              class="username overFl"
              v-if="indexInfo.memberinfo"
            >{{indexInfo.memberinfo.nickname}}</p>
            <!-- <p class="position">主管/ </p> -->
            <p
              :title="indexInfo.department_name"
              class="position overFl"
              v-if="indexInfo.department_name"
            >{{indexInfo.department_name}}</p>
          </div>
        </div>
        <ul class="userHandle">
          <li class="userHandleItem" @click="goEditUserInfo('1')">
            <img src="../assets/image/ulLogo1.png" alt /> 修改个人信息
          </li>
          <li @click="goEditUserInfo('2')">
            <img src="../assets/image/ulLogo2.png" alt /> 账号安全/密码
          </li>
          <!-- 自动审批数据库 -->
          <li @click="goMySql">
            <img src="../assets/image/icon_renw@2x.png" style="width:15px;padding-left:4px;" alt /> 自动审批数据库
          </li>
          <li @click="goEditUserInfo('3')">
            <img src="../assets/image/ulLogo3.png" alt /> 修改企业信息
          </li>
          <li @click="goSelectCompany">
            <img
              src="../assets/image/icon_gs@2x.png"
              style="width:15px;padding-left:3px;padding-right:6px"
              alt
            /> 选择企业
          </li>
          <li @click="handleLoginOut">
            <img src="../assets/image/ulLogo4.png" alt /> 安全退出
          </li>
        </ul>
      </div>
    </transition>
    <transition name="el-zoom-in-top">
      <div v-show="isSettingShow" class="settingSlid">
        <ul class="userHandle help">
          <li class="userHandleItem">系统公告</li>
          <li class="userHandleItem" @click="setProblemClick">提交反馈</li>
          <li class="userHandleItem" @click="handleGoHelp">帮助中心</li>
          <li class="userHandleItem" @click="handleProjectStep">项目流程</li>
          <li class="userHandleItem">版本日志</li>
        </ul>
      </div>
    </transition>
    <!-- 弹窗提示栏 -->
    <div class="tipsRow" v-if="isTipsShow">
      <div class="leftTips">{{tips_str}}</div>
      <div class="rightTips" @click="handleCloseTips">
        <i class="el-icon-close"></i>
      </div>
    </div>
    <!-- 弹窗提示栏 -->
    <!-- 侧重部门弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="55%"
      :before-close="handleClose"
      class="selectClassDia"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age">选择侧重部门</span>
      </div>
      <div class="diaContainer classBody">
        <!-- :style="{backgroundColor:item.bg_color.substr(0,item.bg_color.length-1)+' ,0.5)', backgroundColor:item.bg_color.substr(0,item.bg_color.length-1)+' ,0.5)'}" -->
        <div class="classitem" @click="handleSelectClass('','全部')">
          <div :style="{backgroundColor:'#ccc'}" class="bg"></div>
          <span>{{'全部'}}</span>
        </div>
        <div
          class="classitem"
          v-for="item in classList"
          :key="item.department_id"
          @click="handleSelectClass(item.department_id,item.department_name)"
        >
          <div :style="{backgroundColor:item.bg_color}" class="bg"></div>
          <span>{{item.department_name}}</span>
        </div>
      </div>
    </el-dialog>
    <!-- 未结清项目弹窗 -->
    <el-dialog
      :visible.sync="dialogVisibleReminder"
      width="55%"
      :before-close="handleClosedialogVisibleReminder"
      @close="handleCloseddialogVisibleReminder"
      class="selectClassDia"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age">未结清项目</span>
      </div>
      <div class="diaContainer classBody">
        <el-table
          :header-cell-style="{background:'#40A0F2', padding:'10px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
          :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'5px 0',fontWeight:'400'}"
          :data="indexInfo.reminder_list"
        >
          <el-table-column prop="project_id" width="200" align="center" label="项目id"></el-table-column>
          <el-table-column prop="company_name" align="center" label="项目名称"></el-table-column>
        </el-table>
      </div>
      <div slot="footer" style="margin-top:30px" class="dialog-footer">
        <el-button type="primary" @click="iKnowClick">我已了解</el-button>
        <el-button style="background-color: #ccc;" @click="dialogVisibleReminder = false">暂时关闭</el-button>
      </div>
    </el-dialog>
    <!-- 提交反馈弹窗 -->
    <el-dialog
      :visible.sync="problemVis"
      width="55%"
      :before-close="problemVisClose"
      @close="problemVisClosed"
      class="selectClassDia"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age">提交反馈</span>
      </div>
      <div class="problemBody">
        <el-form class="entryForm" :model="probleForm" label-position="left" label-width="120px">
          <!-- 项目名称 -->
          <div style="box-sizing:border-box;padding:0 10%">
            <div class="diaForm_box">
              <el-form-item label="反馈内容">
                <el-input type="textarea" placeholder="请输入反馈内容" v-model="probleForm.content"></el-input>
              </el-form-item>
              <el-form-item label="电话">
                <el-input type="number" placeholder="请输入您的电话" v-model="probleForm.phone"></el-input>
              </el-form-item>
              <el-form-item label="附件照片">
                <upload-img
                  style="width:100%"
                  :imgList="probleForm.annex"
                  @my-upload-change="upLoadChange"
                  :isSubmit="true"
                ></upload-img>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div slot="footer" style="margin-top:30px" class="dialog-footer">
        <el-button style="background-color: #ccc;" @click="problemVis = false">取 消</el-button>
        <el-button type="primary" @click="problemSubmitClick">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import UploadImg from './UploadImg'
export default {
  data() {
    return {
      dialogVisibleReminder: false,
      selectName: '全部',
      dialogVisible: false,
      // 头像下拉框是否隐藏
      isSelectShow: false,
      // 设置栏下拉框是否隐藏
      isSettingShow: false,
      tabsCurrent: '1',
      member_id: '',
      token: '',
      company_id: '',
      cache_department_id: '',
      indexInfo: {},
      avatarUrl: '',
      punchDisable: false,
      department_model_header: '',
      classList: [],
      isTipsShow: false,
      tips_str: '请修改密码',
      timer: '',
      numData: {},
      problemVis: false,
      probleForm: {
        content: '',
        phone: '',
        annex: [],
      },
    }
  },
  components: {
    UploadImg,
  },
  methods: {
    // *提交提交反馈
    async problemSubmitClick() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('content', this.probleForm.content)
      param.append('phone', this.probleForm.phone)
      param.append('annex', this.probleForm.annex)
      const { data: res } = await this.$http({
        method: 'post',
        url: '/api/Help/set_problem',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      this.problemVis = false
    },
    // 点击提交反馈
    setProblemClick() {
      this.problemVis = true
    },
    // 提交反馈上传
    upLoadChange(data) {
      this.probleForm.annex = data
    },

    async iKnowClick() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      const { data: res } = await this.$http({
        method: 'post',
        url: '/api/Index/is_reminder',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.dialogVisibleReminder = false
    },
    handleCloseTips() {
      this.isTipsShow = false
    },
    handleSelectClass(id, department_name) {
      // this.$store.commit('cache_department_id_store', id)
      localStorage.setItem('bthl_process_cache_department_id_store', id)
      this.cache_department_id = id
      localStorage.setItem(
        'bthl_process_cache_department_Name',
        department_name
      )
      this.selectName = department_name
      this.dialogVisible = false
      // this.$route
      if (
        this.$route.path == '/index/home' &&
        this.$route.query.department_model
      ) {
        // this.$route.query.department_model = ''
        this.$router.push({
          path: '/index/home',
          query: {
            department_model: '',
          },
        })
      }
      location.reload()
    },
    // 获取侧重部门
    async getClassList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/is_business_department',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.classList = res.datas.listInfo
      console.log('部门列表', this.classList)
    },
    // 点击选择侧重部门按钮
    handleSelectClick() {
      this.getClassList()
      this.dialogVisible = !this.dialogVisible
    },
    handleGoHelp() {
      // window.open('https://docs.qq.com/doc/DR3ZtWnFseGh4ZFR')
      this.tabsCurrent = ''
      this.$router.push({
        path: '/projectStep/help',
      })
      this.isSettingShow = false
    },
    handleProjectStep() {
      this.tabsCurrent = ''
      this.$router.push({
        path: '/projectStep/step',
      })
      this.isSettingShow = false
    },
    goSelectCompany() {
      this.$router.push('/join')
    },
    goMyTodo() {
      if (this.$route.path == '/todo') {
        return this.$router.go(0)
      }
      this.$router.push('/todo')
      this.tabsCurrent = ''
    },
    // *获取首页信息
    async getIndexInfo() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Index/overview',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.indexInfo = res.datas
      this.avatarUrl = res.datas.memberinfo.avatar
      if (res.datas.tips == 1) {
        this.isTipsShow = true
      } else {
        this.isTipsShow = false
      }
      this.tips_str = res.datas.tips_str
      if (this.indexInfo.is_reminder == '1') {
        this.dialogVisibleReminder = true
      }
      console.log('首页信息', this.indexInfo)
    },
    // *获取首页信息
    async getNumerData() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      const { data: res } = await this.$http({
        method: 'post',
        url: '/api/Management/msg_upcoming',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.numData = res.datas
    },
    // *判断是不是考勤审批人
    async getPunch() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/ClockInApprove/is_approver',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      if (res.datas.admin_state == '1' || res.datas.is_clockin_user == '1') {
        this.punchDisable = true
      }
      console.log('首页信息', this.indexInfo)
    },
    goMyFlow() {
      if (this.$route.path == '/myFlow') {
        return this.$router.go(0)
      }
      this.$router.push('/myFlow')
      this.tabsCurrent = ''
    },
    LogoClickHomne() {
      this.$router.push('/index')
    },
    // 点击安全退出
    async handleLoginOut() {
      console.log('安全退出')
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Public/login_out',
      })
      console.log('res', res)
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      // 用户id
      window.localStorage.removeItem('btlh_process_member_id')
      // 用户邮箱
      window.localStorage.removeItem('btlh_process_mail')
      // 用户昵称
      window.localStorage.removeItem('btlh_process_nickname')
      // token
      window.localStorage.removeItem('btlh_process_token')
      this.$router.push('/login')
    },
    goProject(val) {
      this.tabsCurrent = 2
      if (val == 1) {
        this.$router.push('/project')
      }
      if (val == 2) {
        this.$router.push('/businessTop')
      }
    },
    goAdmin(val) {
      this.tabsCurrent = 6
      if (val === '成员管理') {
        var query = { type: '1' }
        this.$router.push({
          path: '/admin/organization',
          query,
        })
      } else if (val === '部门管理') {
        var query = { type: '2' }
        this.$router.push({
          path: '/admin/organization',
          query,
        })
      } else if (val === '系统公告') {
        var query = { type: '3' }
        this.$router.push({
          path: '/admin/organization',
          query,
        })
      } else if (val === '项目统计') {
        this.$router.push({
          path: '/admin/statistics',
          query: {
            tab: '1',
          },
        })
      } else if (val === '业务考核') {
        this.$router.push({
          path: '/admin/statistics',
          query: {
            tab: '2',
          },
        })
      } else if (val === '项目设置') {
        this.$router.push({
          path: '/admin/projectSet',
        })
      } else if (val === '审批设置') {
        this.$router.push({
          path: '/admin/approveSet',
        })
      } else if (val === '考勤管理') {
        this.$router.push({
          path: '/admin/punchAdmin',
        })
      }
      //
    },
    // 点击设置
    settingClick() {
      this.isSettingShow = true
    },
    goMySql() {
      this.$router.push({
        path: '/mySql',
      })
    },
    goEditUserInfo(val) {
      this.$router.push({
        path: '/setting/changeUserInfo',
        query: {
          type: val,
        },
      })
      this.tabsCurrent = ''
    },
    // 点击头像
    headerClick() {
      this.isSelectShow = true
    },
    handleIndexTabsClick(val) {
      if (val == '6') return
      this.tabsCurrent = val
      if (val == '1') {
        this.$router.push('/index/home')
      }
      if (val == '2') {
        this.$router.push('/project')
      }
      if (val == '3') {
        this.$router.push('/financeTop')
      }
      if (val == '4') {
        this.$router.push('/clientManage')
      }
      if (val == '5') {
        this.$router.push('/knowledge')
      }
      if (val == '7') {
        this.$router.push('/adminTop')
      }
      if (val == '8') {
        this.$router.push('/tools')
      }
    },
    handleClose() {
      this.dialogVisible = false
    },
    handleClosedialogVisibleReminder() {
      this.dialogVisibleReminder = false
    },
    handleCloseddialogVisibleReminder() {},
    // 提交反馈弹窗
    problemVisClose() {
      this.problemVis = false
    },
    problemVisClosed() {
      this.probleForm = {
        content: '',
        phone: '',
        annex: [],
      }
    },
    judgeRouter() {
      // 根据路由判断顶部导航栏选中项
      if (this.$route.path == '/myFlow') {
        this.tabsCurrent = ''
      }
      if (this.$route.path == '/index/home') {
        this.tabsCurrent = '1'
      }
      if (
        this.$route.path == '/businessTop' ||
        this.$route.path == '/project' ||
        this.$route.path == '/project/details/task' ||
        this.$route.path == '/project/add/task' ||
        this.$route.path == '/project/details/finance' ||
        this.$route.path == '/project/index'
      ) {
        this.tabsCurrent = '2'
      }
      if (this.$route.path == '/financeTop') {
        this.tabsCurrent = '3'
      }
      if (this.$route.path == '/clientManage') {
        this.tabsCurrent = '4'
      }
      if (this.$route.path == '/knowledge') {
        this.tabsCurrent = '5'
      }
      if (
        this.$route.path == '/admin/approveSet' ||
        this.$route.path == '/admin/organization' ||
        this.$route.path == '/admin/statistics' ||
        this.$route.path == '/admin/assessmentStatistics' ||
        this.$route.path == '/admin/punchAdmin' ||
        this.$route.path == '/admin/projectSet'
      ) {
        this.tabsCurrent = '6'
      }
      if (this.$route.path == '/adminTop') {
        this.tabsCurrent = '7'
      }
      if (this.$route.path == '/tools') {
        this.tabsCurrent = '8'
      }
    },
    watchRouterIsProjectFinance() {
      // 监听是否是项目 财务
      if (
        this.$route.path == '/project/details/finance' &&
        this.$route.query.isFromProjectSideBar == '1'
      ) {
        this.$store.commit(
          'process/finance/setProjectName',
          this.$route.query.project_name
        )
        this.$store.commit(
          'process/finance/setProjectId',
          this.$route.query.project_id
        )
        this.$store.commit('process/finance/setIsFromProjectBar', true)
      } else {
        this.$store.commit('process/finance/setIsFromProjectBar', false)
      }
    },
    //如果路由有变化，执行的对应的动作
    watchrouter() {
      // 判断是否侧重部门
      if (this.$route.path == '/index/home') {
        if (this.$route.query.department_model) {
          this.department_model_header = this.$route.query.department_model
          if (this.department_model_header)
            localStorage.setItem(
              'bthl_process_isClassSelectShow',
              this.department_model_header
            )
        }
      }
      // 监听是否是项目 财务
      this.watchRouterIsProjectFinance()
      this.selectName =
        localStorage.getItem('bthl_process_cache_department_Name') || '全部'
      this.department_model_header =
        localStorage.getItem('bthl_process_isClassSelectShow') || ''
      this.judgeRouter()
    },
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  },
  computed: {
    styleObj(color) {
      return {
        '--background-color':
          color.bg_color.substr(0, color.bg_color.length - 1) + ' ,0.5)',
        '--background-color-hover': color,
      }
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.getIndexInfo()
    this.getNumerData()
    this.timer = window.setInterval(() => {
      this.getNumerData()
    }, 120000)
    this.getPunch()
    if (this.$route.query.department_model == 1) {
      this.getClassList()
      this.dialogVisible = true
    }
    this.judgeRouter()
    // 监听是否是项目财务
    this.watchRouterIsProjectFinance()
    // 判断是否侧重部门
    if (this.$route.path == '/index/home') {
      if (this.$route.query.department_model) {
        this.department_model_header = this.$route.query.department_model
        localStorage.setItem(
          'bthl_process_isClassSelectShow',
          this.department_model_header
        )
      }
    }
    this.selectName =
      localStorage.getItem('bthl_process_cache_department_Name') || '全部'
    this.department_model_header =
      localStorage.getItem('bthl_process_isClassSelectShow') || ''
  },

  mounted() {
    let that = this
    document.addEventListener('click', function (e) {
      if (e.target.className == 'header') return
      if (e.target.parentNode.parentNode.parentNode.parentNode) {
        if (
          e.target.className != 'headerSlid' &&
          e.target.parentNode.className != 'headerSlid' &&
          e.target.parentNode.parentNode.className != 'headerSlid' &&
          e.target.parentNode.parentNode.parentNode.className != 'headerSlid' &&
          e.target.parentNode.parentNode.parentNode.parentNode.className !=
            'headerSlid'
        ) {
          that.isSelectShow = false
        }
      } else if (e.target.parentNode.parentNode.parentNode) {
        if (
          e.target.className != 'headerSlid' &&
          e.target.parentNode.className != 'headerSlid' &&
          e.target.parentNode.parentNode.className != 'headerSlid' &&
          e.target.parentNode.parentNode.parentNode.className != 'headerSlid'
        ) {
          that.isSelectShow = false
        }
      } else if (e.target.parentNode.parentNode) {
        if (
          e.target.className != 'headerSlid' &&
          e.target.parentNode.className != 'headerSlid' &&
          e.target.parentNode.parentNode.className != 'headerSlid'
        ) {
          that.isSelectShow = false
        }
      } else if (e.target.parentNode) {
        if (
          e.target.className != 'headerSlid' &&
          e.target.parentNode.className != 'headerSlid'
        ) {
          that.isSelectShow = false
        }
      } else {
        if (e.target.className != 'headerSlid') {
          that.isSelectShow = false
        }
      }
    })
    document.addEventListener('click', function (e) {
      if (e.target.className == 'logo_setting') return
      if (e.target.parentNode.parentNode.parentNode.parentNode) {
        if (
          e.target.className != 'settingSlid' &&
          e.target.parentNode.className != 'settingSlid' &&
          e.target.parentNode.parentNode.className != 'settingSlid' &&
          e.target.parentNode.parentNode.parentNode.className !=
            'settingSlid' &&
          e.target.parentNode.parentNode.parentNode.parentNode.className !=
            'settingSlid'
        ) {
          that.isSettingShow = false
        }
      } else if (e.target.parentNode.parentNode.parentNode) {
        console.log(
          'e.target.parentNode.parentNode.parentNode',
          e.target.parentNode.parentNode.parentNode.className
        )
        if (
          e.target.className != 'settingSlid' &&
          e.target.parentNode.className != 'settingSlid' &&
          e.target.parentNode.parentNode.className != 'settingSlid' &&
          e.target.parentNode.parentNode.parentNode.className != 'settingSlid'
        ) {
          that.isSettingShow = false
        }
      } else if (e.target.parentNode.parentNode) {
        if (
          e.target.className != 'settingSlid' &&
          e.target.parentNode.className != 'settingSlid' &&
          e.target.parentNode.parentNode.className != 'settingSlid'
        ) {
          that.isSettingShow = false
        }
      } else if (e.target.parentNode) {
        if (
          e.target.className != 'settingSlid' &&
          e.target.parentNode.className != 'settingSlid'
        ) {
          that.isSettingShow = false
        }
      } else {
        if (e.target.className != 'settingSlid') {
          that.isSettingShow = false
        }
      }
    })

    // document.addEventListener('click', function (e) {
    //   if (e.target.className == 'logo_setting') return
    //   if (
    //     e.target.className != 'settingSlid' &&
    //     e.target.parentNode.className != 'settingSlid' &&
    //     e.target.parentNode.parentNode.className != 'settingSlid' &&
    //     e.target.parentNode.parentNode.parentNode.className != 'settingSlid'
    //   ) {
    //     that.isSettingShow = false
    //   }
    // })
  },
  watch: {
    $route: 'watchrouter', //路由变化时，执行的方法
  },
}
</script>
<style lang="less" scoped>
.index_header_box {
  box-sizing: border-box;
  padding: 0 50px;
  position: relative;
  box-shadow: 0px 30px 60px 0px rgba(0, 0, 0, 0.04);
  height: 8%;
  background-color: #fff;
  width: 100% !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 70%;
    img {
      width: 18%;
    }
    // tab
    .index_tabs {
      display: flex;
      padding-top: 10px;
      width: 60%;
      justify-content: space-between;
      li {
        cursor: pointer;
        white-space: nowrap;
        font-size: 18px;
        font-weight: 700;
        color: #666;
        position: relative;
        .underLine {
          position: absolute;
          width: 100%;
          height: 2px;
          background-color: #40a0f2;
        }
      }
      .indexTabsActive {
        color: #128bf1;
      }
    }
  }
  .right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 30%;

    img {
      cursor: pointer;
    }
    .logo_setting,
    .logo_fly,
    .logo_position {
      width: 25px;
      height: 25px;
      margin-left: 40px;
    }
    .header {
      margin-left: 40px;
      width: 48px;
      height: 48px;
      border-radius: 24px;
    }
  }
  // 头像下啦框
  .headerSlid {
    position: absolute;
    z-index: 600;
    top: 100%;
    right: 3%;
    width: 280px;
    height: 400px;
    border-radius: 5px;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
    .headerInfor {
      border-radius: 5px 5px 0 0;
      height: 130px;
      background: url(../assets/image/headerSlid.png) no-repeat;
      background-size: 100% 100%;
      display: flex;
      .SlidLeft {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 40%;
        box-sizing: border-box;
        padding-left: 10%;
        margin-right: 5%;
        img {
          width: 75px;
          height: 75px;
          border-radius: 50%;
        }
      }
      .SlidRight {
        .username {
          font-size: 18px;
          color: #ffffff;
          margin-top: 30px;
          margin-bottom: 15px;
        }
        .position {
          font-size: 16px;
          color: #fff;
        }
        .overFl {
          width: 120px;
          overflow: hidden; /*超出部分隐藏*/
          white-space: nowrap; /*不换行*/
          text-overflow: ellipsis; /*超出部分文字以...显示*/
        }
      }
    }
    // 操作栏
    .userHandle {
      height: calc(100% - 130px);
      padding: 0 20px;
      li {
        cursor: pointer;
        display: flex;
        align-items: center;
        height: 16.5%;
        font-size: 14px;
        color: #666;
        border-bottom: 1px dashed #f4f5f6;
        img {
          width: 21px;
          margin-left: 62px;
          margin-right: 10px;
        }
      }
      li:last-child {
        border-bottom: none;
      }
      li:hover {
        color: #333;
      }
    }
  }
  // 设置下拉框
  .settingSlid {
    position: absolute;
    z-index: 600;
    top: 100%;
    right: 8%;
    width: 200px;
    height: 250px;
    border-radius: 5px;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
    .help {
      height: 100%;
      li {
        height: 20%;
      }
    }
    ul {
      height: 100%;
      padding: 10px 20px;
      box-sizing: border-box;
      li {
        height: 25%;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #666;
        border-bottom: 1px dashed #f4f5f6;
      }
      li:last-child {
        border-bottom: none;
      }
      li:hover {
        color: #333;
      }
    }
  }
}
// 修改下拉
.el-dropdown-menu {
  top: 8% !important;
  margin-top: 0;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
  /deep/.popper__arrow {
    transform: translateX(-300px);
  }
  transform: translateX(300px);
  // 修改箭头
  // /deep/.popper__arrow {
  //   border-bottom-color: #fff !important;
  //   // border-bottom-width: 20px;
  //   width: 1px;
  //   top: -30px;
  //   border-width: 15px;
  // }
  // 修改箭头
}

.drop_container {
  box-sizing: border-box;
  width: 360px !important;
  padding: 0 40px;
  padding-top: 15px;
}

  .adminItem {
    width: 100%;
    .adminTitle {
    font-size: 16px;
    color: #128bf1;
    cursor: default;
    display: flex;
    align-items: center;
  }
  .itemsContainer {
    display: flex;
    justify-content: space-between;
    padding: 20px 10px;
    li {
      font: 14px sans-serif;
      cursor: pointer;
      color: #666;
    }
    li:hover {
      color: #333;
    }
  }
  .itemsContainerss {
    justify-content: flex-start;
    li {
      width: 40%;
    }
  }
  .adminTitle::before {
    content: '';
    display: block;
    width: 2px;
    height: 14px;
    background: #40a0f2;
    margin-right: 10px;
  }
}

.adminDropContainer {
  .adminItem {
    .itemsContainer {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      column-gap: 0;
      row-gap: 0;
      justify-content: initial;
      li {
        width: auto;
        box-sizing: border-box;
      }
    }
    .itemsContainerss {
      li {
        width: auto;
      }
    }
  }
}
// 修改弹窗样式
.selectClassDia /deep/.el-dialog {
  border-radius: 10px;
  .el-dialog__header {
    border-radius: 10px 10px 0 0;
    background-color: #f4f5f6;
    font-size: 20px;
    color: #333;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 40px;
  }
  .classBody {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    .classitem {
      cursor: pointer;
      width: 230px;
      font-size: 20px;
      font-weight: 700;
      color: #333;
      margin-right: 20px;
      margin-bottom: 10px;
      height: 100px;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      // opacity: 0.5;
      .bg {
        width: 100%;
        height: 100%;
        border-radius: 10px;
        opacity: 0.5;
      }
      span {
        display: block;
        color: rgba(0, 0, 0, 1);
        z-index: 22;
        position: absolute;
      }
    }
    .bg:hover {
      opacity: 1;
    }
  }
}
.selectClass {
  width: 12%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #606266;
  border-color: #dcdfe6;
  background-color: #fff;
}
// 消息提醒栏
.tipsRow {
  position: fixed;
  top: 8%;
  left: 0;
  width: 100%;
  background-color: #d1e6fa;
  height: 40px;
  z-index: 300;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 20px;
  justify-content: space-between;
  .leftTips {
    width: 80%;
    overflow: hidden; /*超出部分隐藏*/
    white-space: nowrap; /*不换行*/
    text-overflow: ellipsis; /*超出部分文字以...显示*/
    font-weight: 700;
    color: #37aae8;
  }
  .rightTips {
    cursor: pointer;
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;

    /deep/.el-icon-close {
      font-weight: 700;
      color: #446bb0;
    }
  }
}
// 修改dia尾部按钮样式
.dialog-footer {
  width: 100%;
  display: flex;
  padding-left: 30%;
  .el-button {
    // width: 180px;
    width: 23%;
    height: 50px;
    padding: 0;
    font-size: 20px;
    font-weight: normal;
    color: #fff;
    border: none;
    border-radius: 25px;
    background-color: #40a0f2;
    margin-bottom: 40px;
  }
  .el-button:first-child {
    margin-right: 5%;
  }
}
.el-table::before {
  display: none;
}
.diaContainer {
  height: 40vh;
  overflow-y: scroll;
}
// 问题反馈弹窗
/deep/.problemBody {
  .el-form-item__label {
    font-size: 16px;
    color: #333;
    font-weight: 700;
    box-sizing: border-box;
    padding-right: 40px;
    line-height: 40px;
  }
  .el-form-item__content {
    .el-input__inner {
      font-size: inherit;
      width: 100%;
      height: 40px;
      border-radius: 0;
    }
    .el-textarea__inner {
      padding: 10px 10px;
      min-height: 170px !important;
      font-size: inherit;
      resize: none;
      border-radius: 0;
      font-family: Microsoft YaHei;
    }
    .el-upload-dragger {
      width: 140px;
      height: 40px;
    }
  }
}
</style>
